import { get } from 'lodash';

import { numberUnmask, removeSpace } from 'utils/masks';

const FundingAccountSchema = {
  accountHolderName: [{
    rule: 'required',
    isValid: (input, err, opt, formData) => {
      if (get(formData, 'selectedAccount.value') !== 'addNew' && get(formData, 'hasBankStoredAccounts')) {
        return true;
      }
      if (!input || removeSpace(input).length === 0) {
        return 'The input field is required';
      }
      if (input.length > 40) {
        return 'The input field is too long';
      }
      if (input.trim().split(' ').length < 2) {
        return 'Please enter your full name';
      }
      if (!/^[a-zA-Z\s-']+$/.test(input)) {
        return 'Please enter a valid name, with only letters, - and \'.';
      }
      return true;
    },
  }],
  routingNumber: [{
    rule: 'required',
    isValid: (input, err, opt, formData) => {
      if (get(formData, 'selectedAccount.value') !== 'addNew' && get(formData, 'hasBankStoredAccounts')) {
        return true;
      }
      if (!input) {
        return 'The input field is required';
      }
      if (numberUnmask(input).length < 9 || !formData.isValidRoutingNumber) {
        return 'Routing Number is not valid';
      }
      return true;
    },
  }],
  accountNumber: [{
    rule: 'required',
    isValid: (input, err, opt, formData) => {
      if (get(formData, 'selectedAccount.value') !== 'addNew' && get(formData, 'hasBankStoredAccounts')) {
        return true;
      }
      if (!input) {
        return 'The input field is required';
      }
      return true;
    },
  }],
  accountType: [{
    rule: 'required',
    isValid: (input, err, opt, formData) => {
      if (get(formData, 'selectedAccount.value') !== 'addNew' && get(formData, 'hasBankStoredAccounts')) {
        return true;
      }
      if (!input) {
        return 'The input field is required';
      }
      return true;
    },
  }],
};

export default FundingAccountSchema;
